















import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import FlatButton from '@/components/common/FlatButton.vue';
import PortalIcon from '@/components/icons/PortalIcon.vue';

import InstallMixin from '@/mixins/install';

import MainStorage from '@/storage/main';

import { Outcome } from '@/services/install-prompt';

@Component({
  components: { PortalIcon, FlatButton },
})
export default class InstallPrompt extends mixins(InstallMixin) {
  @Prop({ type: String })
  readonly appearDelay?: string;

  delay: string | null = null;

  outcome: string | null = null;

  get shown() {
    return this.canInstall && !this.promptDismissed && !this.outcome;
  }

  get styles() {
    return {
      'transition-delay': this.delay,
    };
  }

  @Watch('outcome')
  outcomeChanged(outcome: string) {
    MainStorage.saveInstallPrompt(outcome);
  }

  mounted() {
    this.outcome = MainStorage.getInstallPrompt();
    this.delay = (!this.outcome && this.appearDelay) || null;
  }

  handleInstall() {
    this.promptInstall().then(outcome => {
      this.outcome = outcome || null;
    });
  }

  handleClose() {
    this.outcome = Outcome.DISMISSED;
  }

  handleTransitionEnter() {
    this.delay = null;
  }
}
